const GET_TESTIMONIAL_LIST = 'GET_TESTIMONIAL_LIST';
const GET_TESTIMONIAL_DATA_LOADING = 'GET_TESTIMONIAL_DATA_LOADING';

export const TYPES_TESTIMONIAL = { GET_TESTIMONIAL_LIST, GET_TESTIMONIAL_DATA_LOADING };
